import React, { useState, useEffect } from "react";
import { HashLink as Link } from "react-router-hash-link";
import logo from "./../../assets/img/logo.svg";
import qualiopi from "./../../assets/img/certif-Qualiopi.png";

const Footer = () => {
  const [year, setYear] = useState(new Date().getFullYear());

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    setYear(currentYear);
  }, []);

  return (
    <footer className="footer footer-main">
      <article className="top-footer">
        <img className="footer-logo" src={logo} alt="logo" />
        <ul>
          <Link to="/#about" className="nav-link">
            À PROPOS
          </Link>
          <Link to="/formations/#formation-hero" className="nav-link">
            NOS FORMATIONS
          </Link>
          <Link to="/#entreprise" className="nav-link">
            ENTREPRISES
          </Link>
          <Link to="/contact/#contact" className="nav-link">
            CONTACT
          </Link>
        </ul>
        <img className="qualiopi-logo" src={qualiopi} alt="logo qualiopi" />
      </article>
      <article className="bottom-footer">
        <ul>
          <a href="mailto:direction@up4mind.com" className="bottom-nav-link">
            direction@up4mind.com
          </a>
          <a href="tel:+330492136354" className="bottom-nav-link">
            04 92 13 63 54
          </a>
          <Link to="/mentions-legales/" className="bottom-nav-link">
            Mention légal
          </Link>
        </ul>
        <div>
          <p>
            Designed with 💜 by{" "}
            <a className="" href="https://maelcorp.com/">
              maelcorp.com
            </a>
          </p>
          <p>Copyright © {year} UP4MIND</p>
        </div>
      </article>
    </footer>
  );
};

export default Footer;
